export default "__VITE_ASSET__osRWk9cg__"